module.exports = __webpack_public_path__ + "static/media/2.840f3e3f.svg";